import { useEffect } from 'react';
import { useQuery } from '@tanstack/react-query';
import { useTheme } from 'next-themes';
import { parseUserPreferences } from '@/domain/preferences/userPreferences';
import { useAuth } from '@/hooks/useAuth';
import { supabase } from '@/integrations/supabase/client';

export const UserPreferenceSync = () => {
  const { user, loading: authLoading } = useAuth();
  const { setTheme } = useTheme();
  const preferencesQuery = useQuery({
    queryKey: ['user-preferences', user?.id],
    queryFn: async () => {
      const { data, error } = await supabase
        .from('user_preferences')
        .select('*')
        .eq('user_id', user!.id)
        .maybeSingle();

      if (error) throw error;
      return data;
    },
    enabled: !authLoading && Boolean(user?.id),
    staleTime: 10 * 60 * 1000,
  });

  useEffect(() => {
    if (authLoading) return;
    if (!user?.id) {
      setTheme('system');
      return;
    }
    if (!preferencesQuery.data) return;

    const preferences = parseUserPreferences(preferencesQuery.data);
    setTheme(preferences.theme);
  }, [authLoading, preferencesQuery.data, setTheme, user?.id]);

  return null;
};
